/**
 * Generated by orval v8.9.1 🍺
 * Do not edit manually.
 * Praetoid Dashboard API
 * OpenAPI spec version: 1.0
 */
import * as zod from 'zod';

export const WebhookEventTypeListResponse = zod
	.array(
		zod
			.object({
				label: zod.string().describe('Human-readable label for the event type'),
				value: zod.string().describe('Event type identifier (e.g. case.created)')
			})
			.describe('A webhook-eligible event type')
	)
	.describe('List of webhook-eligible event types');

export type WebhookEventTypeListResponse = zod.input<typeof WebhookEventTypeListResponse>;
export type WebhookEventTypeListResponseOutput = zod.output<typeof WebhookEventTypeListResponse>;
